import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CORE_CONFIGURATION } from '../configuration';
import { setObjectParams } from '../util.class';
import { BaseApiService } from '../api/base-api.service';
import { ApiModule } from '../api';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class SessionApiService {
  constructor(private http: BaseApiService, @Inject(CORE_CONFIGURATION) private config) {}

  /**
   * get list key map for AWS endpoint
   * @param path
   */
  getConfigurationKeyAWS(path: string, hideError = false): Observable<any> {
    return this.http.get({
      apiBasePath: '',
      path: this.config.apiHostAWS + '/configuration/v1/configuration', // configuration/v1/configuration?configurationKey=endpoints
      hideError,
      responseType: null,
      awsApi: true
    });
  }


}
